import React from "react";
import Deploy from "./product/deploy";
import Monitor from "./product/monitor";

type Props = object;

function Products({}: Props) {
  return (
    <section id="features">
      <Deploy />

      <Monitor />
    </section>
  );
}

export default Products;
